
import { BaseService } from '../base/base.service';
import { AppService } from '../main/app.service';

export class ITask {
    id: string;
    name: string;
    description: string;
    tags: string[];
    endDate: any;
    userId: string;
    userName: string;
    accountId: string;
    locationId: string;
    teamId: string;
    contactId: string;
    employeeId: string;
}

export class TasksService extends BaseService<ITask> {
    constructor(Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'crm/Tasks');
    }

    public getArchive = (queryParams = null) => {
        return this.Restangular.all(this.itemName).customGET('archive', queryParams).then((list: Restangular.ICollection) => {
            this.list = list.plain().value;
            return this.listLoaded(this.list);
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/tasks.service.ts